import axios from 'axios';
import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;
const WORKFLOW_ENGINE_API = window.AppConfig.WORKFLOW_ENGINE_API;

export default class TenantService {

    /**
     * This function is used for Tenants related tasks.
     * @return {}
     */
    static async create(requestBody) {
        return ApiService.PostData(API_URLS.TENANTS, requestBody, 'tenant');
    }

    static async createTenantOnCamunda(requestBody) {
        try {
            return axios.post(`${WORKFLOW_ENGINE_API}/${API_URLS.TENANTS_COPY}`, requestBody).data.body;

        } catch (error) {
            console.log(error.message);
        }
    }

    static async getById(id) {
        return ApiService.GetData(`${API_URLS.TENANTS}/${id}`, 'tenant', false);
    }

    static async getByShortName(name) {
        return ApiService.GetData(`${API_URLS.TENANTS}/getByShortName/${name}`, 'tenant', false);
    }

    static async getAllTenants() {
        return ApiService.GetData(API_URLS.TENANTS, 'tenant', false);
    }

    static async edit(id, requestBody) {
        return ApiService.PutData(`${API_URLS.TENANTS}/${id}`, requestBody, 'tenant');
    }

    static async createCopyOfBpmnAndDeploy(id) {
        return ApiService.PostData(`${API_URLS.TENANTS}/${id}/${API_URLS.BPMN_DEPLOYMENT}`, {}, 'tenant');
    }

    static async downloadTenantBpmn(tenant_id, bpmn_id) {
        return ApiService.GetData(`${API_URLS.TENANTS}/${tenant_id}/${API_URLS.BPMN_DEPLOY}/${bpmn_id}/${API_URLS.DOWNLOAD}`, 'tenant');
    }

    static async getSignedUrl(tenant_id, bpmn_id) {
        return ApiService.GetData(`${API_URLS.TENANTS}/${tenant_id}/${API_URLS.BPMN_DEPLOY}/${bpmn_id}/${API_URLS.SIGNED_URL}`, 'tenant');
    }

    static async redeployNewBpmn(tenant_id, bpmn_id) {
        return ApiService.PatchData(`${API_URLS.TENANTS}/${tenant_id}/${API_URLS.BPMN_DEPLOY}/${bpmn_id}/${API_URLS.REDEPLOY}`, {}, 'tenant');
    }

    static async getAllForms(id) {
        return ApiService.GetData(`${API_URLS.TENANTS}/${id}/${API_URLS.GET_HTML_FORM}`, 'tenant');
    }

    static async downloadForm(tenant_id, requestBody) {
        const response = await ApiService.PostData(`${API_URLS.TENANTS}/${tenant_id}/${API_URLS.DOWNLOAD_HTML_FORMS}`, requestBody, 'tenant');
        return response.data;
    }

    static async updateForm(tenant_id, requestBody) {
        const response = await ApiService.PostData(`${API_URLS.TENANTS}/${tenant_id}/${API_URLS.UPLOAD_HTML_FORMS}`, requestBody, 'tenant');
        return response.data;
    }

    static async delete(id) {
        return ApiService.DeleteData(`${API_URLS.TENANTS}/${id}`, 'tenant');
    }

    static async invalidateCache() {
        return ApiService.PatchData(`${API_URLS.TENANTS}/${API_URLS.INVALIDATE_CACHE}`, {}, 'tenant');
    }

    static async toggleBpmnStatus(tenantId, bpmnId) {
        return ApiService.PatchData(`${API_URLS.TENANTS}/${tenantId}/${API_URLS.BPMN_DEPLOY}/${bpmnId}/${API_URLS.STATUS}`, {}, 'tenant');
    }
}
